import * as React from 'react';
import { SVGProps } from 'react';

const IconJiraSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.674 2H5.912c0 .452.179.885.497 1.205.319.32.75.499 1.2.499h.694v.67A1.7 1.7 0 0 0 10 6.078v-3.75A.327.327 0 0 0 9.674 2Z" />
    <path d="M7.723 3.97H3.96a1.7 1.7 0 0 0 1.697 1.703h.693v.673a1.7 1.7 0 0 0 1.698 1.702v-3.75a.327.327 0 0 0-.326-.327Z" />
    <path d="M5.762 5.923H2a1.7 1.7 0 0 0 1.698 1.703h.695v.672c.001.939.76 1.7 1.695 1.702V6.25a.327.327 0 0 0-.326-.327Z" />
  </svg>
);
export default IconJiraSizeXs;
